import { EOperationProofType } from '../_enums/proofTypes.code';

export interface OperationProof {
  id?: string;
  fileName?: string;
  inputProductProoved?: string[];
  outputProductProoved?: string[];
  vehicleProoved?: string[];
  proovedTypes?: EOperationProofType[];
  createDate?: Date;
  addedBy?: string;
  comment?: string;
}

export interface OperationProofWithFile extends OperationProof {
  filePath?: string;
  fileContent?: string;
}
